import _ from 'lodash';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import CustomerDataTable from '../components/CustomerDataTable';
import { SocketRPC, socketEmit } from '../lib/socket';
import { useCustomerData, useCustomerDataSearchParams } from '../store/customer-data';
import useOrderSources from '../store/order-sources';
import useProducerLocations from '../store/producer-locations';
import useUser from '../store/user';

function arrayToCSV(csvData) {
	return csvData.map(row => row.map(String).map(cell => cell.replaceAll('"', '""'))
		.map(cell => `"${cell}"`)
		.join(',')
	).join('\r\n');
}

function downloadCSV(content, fileName) {
	const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);

	const downloadLink = document.createElement('a');
	downloadLink.href = url;
	downloadLink.setAttribute('download', fileName);
	downloadLink.click();
}


export default function CustomerDataPage() {
	const { user } = useUser();
	const { producerKey, orderSourceKey, partnerKey } = user || {};
	const { customerData, setCustomerData, customerDataLoaded, setCustomerDataLoaded } = useCustomerData();
    const { customerDataSearchParams, setCustomerDataSearchParams, activePage, setActivePage, pageSize, setPageSize, sortField, setSortField, sortOrder, setSortOrder } = useCustomerDataSearchParams();
	const { producerLocations } = useProducerLocations();
	const { orderSources, setOrderSources } = useOrderSources();

	useEffect(() => {
		if (orderSources && orderSources.length > 0) return;

		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.GetOrderSources, { producerKey });
			})
			.then((res) => {
				if (!res.success) {
					throw new Error(res.error);
				}
				const orderSources = _.chain(res.orderSources).map((orderSource) => {
					return {
						orderSourceName: orderSource["order_source"],
					}
				}).uniqBy('orderSourceName').value();
				setOrderSources(orderSources);
			})
	}, []);

	useEffect(() => {
		setCustomerDataLoaded(false);
		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.GetCustomerData, {
					...(customerDataSearchParams || {}),
					user,
					producerKey,
					...(orderSourceKey && { orderSourceKey }),
					// partnerKey,
					pageIndex: activePage,
					pageSize,
					sortField: sortProps.sortField,
					sortOrder: sortProps.sortOrder,
				});
			})
			.then((res) => {
				if (!res.success) {
					setCustomerData([]);
					throw new Error(res.error);
				}
				console.log('res.caa', res.customerData);
				setCustomerData(res.customerData);
				setCustomerDataLoaded(true);
			})
			.catch((err) => {
				toast.error(`Error getting customer data. Please try again`);
				setCustomerDataLoaded(true);
				console.log(`Could not get customer data`, err);
			});
	}, [JSON.stringify(customerDataSearchParams), activePage, pageSize, sortField, sortOrder]);

	const searchAndDownloadCSV = () => {
		setCustomerDataLoaded(false);
		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.GetCustomerData, {
					...(customerDataSearchParams || {}),
					user,
					producerKey,
					...(orderSourceKey && { orderSourceKey }),
					// partnerKey,
				});
			})
			.then((res) => {
				if (!res.success) {
					throw new Error(res.error);
				}
				const { customerData } = res;
				const csvData = customerData.map((customer) => [
					customer.consumerName || '',
					customer.consumerPhone || '',
					customer.consumerEmail || '',
					`${customer.consumerStreetNumber || ''} ${customer.consumerStreet || ''}`,
					customer.consumerCity || '',
					customer.consumerState || '',
					customer.consumerZip || '',
					customer.totalOrderCount || '',
					customer.averageOrderSubtotal || '',
					customer.aggregateOrderSubtotal || '',
				]);
				csvData.unshift(['Name', 'Phone', 'Email', 'Address', 'City', 'State', 'Zip', 'Order Count', 'Average Order Subtotal', 'Aggregate Order Subtotal']);
				const csv = arrayToCSV(csvData);
				const { startDate, endDate, producerLocationKey } = customerDataSearchParams || {};
				const csvTitle = `${startDate?.toString().replace(/[^A-Za-z0-9]/g, "")}_${endDate?.toString().replace(/[^A-Za-z0-9]/g, "")}${producerLocationKey ? `_${producerLocationKey}` : ''}`
				downloadCSV(csv, csvTitle);
				setCustomerDataLoaded(true);
			})
			.catch((err) => {
				toast.error(`Error downloading CSV. Please try again`);
				setCustomerDataLoaded(true);
			});
	}

	const paginationProps = {
		activePage,
		setActivePage,
		pageSize,
		setPageSize,
	};

	const sortProps = {
		sortField,
		setSortField,
		sortOrder,
		setSortOrder,
	}

	const CustomerDataTableProps = {
		customerData,
		customerDataLoaded,
		producerLocations,
		orderSources,
		setCustomerDataSearchParams,
		customerDataSearchParams,
		paginationProps,
		searchAndDownloadCSV,
		sortProps,
	};

	return CustomerDataTable(CustomerDataTableProps);
}
